(ns teamoesterreich.user-mode.profile.profile-wanado
  (:require
    [clojure.string]
    [goog.date.DateTime]
    [reagent-material-ui.components :as mui]
    [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
    [reagent-material-ui.icons.save :refer [save]]
    [reagent.core :as r]
    [teamoesterreich.firebase.remote-config :as remote-config]
    [teamoesterreich.store :as store]
    [teamoesterreich.text.get-text :as txt]
    [teamoesterreich.user-mode.actions :as a]
    [teamoesterreich.user-mode.navigation.bottom-bar :as bottom-bar]
    [teamoesterreich.user-mode.ui-helper.are-you-sure-modal :as ays-modal]
    [teamoesterreich.util.log :as log]))


(defn save-user [user-obj]
  (a/set-user-details user-obj))

(defn wanado-checkbox [val-fn changed-fn on-change-fn]
  (fn [name text key]
    [mui/grid
     {:container false
      :md        12                                         ;medium: 960px
      :xs        12                                         ;extra-small: 0px
      :style     {:padding "15px" :backgroundColor (if (changed-fn key) "#ffd6d2" "#ffffff")}
      }

     [mui/form-control-label
      {
       :control (r/as-element
                  [mui/checkbox {
                                 :checked  (val-fn key)
                                 :color    "primary"
                                 :onChange (on-change-fn key)
                                 }])
       :label   (str name)
       }
      ]
     [:br]
     [:span text]
     ]
    ))

(defn get-it []
  (let [!profile-state (r/cursor store/app-state [:profile-state])
        !actual-user (r/cursor store/app-state [:actual-user])
        !wanado-form (r/cursor !profile-state [:wanado-form])
        !lose-data-modal (r/cursor !profile-state [:wanado-form :show-lose-data-form-modal])

        tafel? (or (remote-config/get-boolean "help_card_tafel") false)


        u-on-change-fn (fn [keys] (fn [_ val] (swap! !wanado-form assoc-in keys val) (log/log "OnChange" keys val @!wanado-form)))
        u-val-fn (fn [keys] (if (nil? (get-in @!wanado-form keys)) (get-in @!actual-user keys) (get-in @!wanado-form keys)))
        u-changed?-fn (fn [keys] (and (not (nil? (get-in @!wanado-form keys)))
                                      (not= (get-in @!wanado-form keys) (get-in @!actual-user keys))))
        do-save? (or
                   (u-changed?-fn [:help :manual_work])
                   (u-changed?-fn [:help :professional_skills])
                   (u-changed?-fn [:help :online])
                   (u-changed?-fn [:help :work_hours_possible])
                   (u-changed?-fn [:help :own_car])

                   (u-changed?-fn [:help :KatAdministrativen])
                   (u-changed?-fn [:help :KatNachbarschaftshilfe])
                   (u-changed?-fn [:help :KatInformationstgk])
                   (u-changed?-fn [:help :KatBBetreuung])
                   (u-changed?-fn [:help :KatLogistik])
                   (u-changed?-fn [:help :KatSicherungsarbeiten])
                   (u-changed?-fn [:help :KatAufraeumungsarbeiten])
                   (u-changed?-fn [:help :KatHilfsaktivitaeten])

                   (u-changed?-fn [:help :NormNachbarschaftshilfe])
                   (u-changed?-fn [:help :NormEinmalAufgaben])
                   (u-changed?-fn [:help :NormProjekten])
                   (u-changed?-fn [:help :NormLogistik])
                   (u-changed?-fn [:help :NormRotkreuzVeranstaltungen])
                   (u-changed?-fn [:help :NormAdministrativen])
                   (u-changed?-fn [:help :NormCampaigning])
                   (u-changed?-fn [:help :NormHilfsaktivitäten])

                   (u-changed?-fn [:help :tafel_once])
                   (u-changed?-fn [:help :tafel_regular])
                   (u-changed?-fn [:help :tafel_driver])
                   (u-changed?-fn [:help :tafel_helper])
                   (u-changed?-fn [:help :tafel_deliverer])
                   )
        u-wanado-checkbox (wanado-checkbox u-val-fn u-changed?-fn u-on-change-fn)
        save-fn (fn []
                  (log/out "save form")
                  (save-user @!wanado-form)
                  (swap! !profile-state assoc :wanado-form {})
                  ;(.scrollTo js/window 0 0)
                  ;(a/set-page-back)
                  )

        real-back-fn (fn []
                       (.scrollTo js/window 0 0)
                       (swap! !profile-state assoc :wanado-form {})
                       (a/set-page-back))

        back-fn (fn [_]
                  (log/out "back-fn called")
                  (if do-save?
                    (swap! !wanado-form assoc :show-lose-data-form-modal true)
                    (real-back-fn)))
        ]
    (bottom-bar/set-actions back-fn (when do-save? save-fn))

    [mui/grid
     {:container  true
      :direction  "column"
      :justify    "center"
      :alignItems "center"
      :spacing    4
      :style      {:marginTop "25px"}
      }
     [mui/grid
      {:container false
       :md        6                                         ;medium: 960px
       :xs        12                                        ;extra-small: 0px
       }
      [ays-modal/are-you-sure-modal !lose-data-modal "Dieses Formular hat nicht gespeicherte Daten. Willst du es wirklich schließen?" "Eingabe verwerfen"
       real-back-fn]
      [mui/paper {:class ""
                  :style {:textAlign "left" :padding "25px"
                          }}
       [mui/grid
        {:container  true
         :direction  "row"
         :justify    "space-between"
         :alignItems "flex-start"
         :spacing    1
         }
        [mui/grid
         {:container false
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "15px"}
          }
         [:h1
          "Was ich tun möchte"]
         [:span
          "Für den Einsatz ist es für uns wichtig zu wissen, welche Tätigkeiten die einzelnen Mitglieder im Einsatzfall übernehmen können und wollen."]
         ]


        [mui/grid
         {:container false
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "15px 15px 0 15px"}
          }
         [:h2
          "Allgemein"]
         [:p
          "Blockinfo Allgemein"
          ]
         ]
        (u-wanado-checkbox "Körperliche Arbeit"
                           "Ich bin bereit, körperliche Arbeit zu leisten."
                           [:help :manual_work])
        (u-wanado-checkbox "Fachspezifische Kenntnisse"
                           "Ich bin bereit, eigene fachspezifische Kenntnisse einzubringen."
                           [:help :professional_skills])
        (u-wanado-checkbox "Online Aktivitäten"
                           "Ich bin bereit, auch Aufgaben ohne persönliche\nAnwesenheit zu erledigen (z.B.: online)."
                           [:help :online])
        (u-wanado-checkbox "Dienstfreistellung möglich"
                           "Für die Dauer des Einsatzes besteht die Möglichkeit\neiner Dienstfreistellung."
                           [:help :work_hours_possible])
        (u-wanado-checkbox "Eigenes Fahrzeug"
                           "Für die Anreise zu einem Einsatz habe ich ein eigenes\nFahrzeug."
                           [:help :own_car])




        [mui/grid
         {:container false
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "15px 15px 0 15px"}
          }
         [:h2
          "Katastrophenfall"]
         [:p
          "Bei einer Katastrophe bin ich bereit ..."
          ]
         ]
        (u-wanado-checkbox "... zur Unterstützung bei administrativen Tätigkeiten."
                           ""
                           [:help :KatAdministrativen])
        (u-wanado-checkbox "... zur Nachbarschaftshilfe."
                           ""
                           [:help :KatNachbarschaftshilfe])
        (u-wanado-checkbox "... zur Unterstützung bei Informationstätigkeiten (z.B. Flugblätter verteilen, im Call-Center)."
                           ""
                           [:help :KatInformationstgk])
        (u-wanado-checkbox "... zur Unterstützung bei der Betreuung von Menschen mit besonderen Bedürfnissen."
                           ""
                           [:help :KatBBetreuung])
        (u-wanado-checkbox "... zur Unterstützung bei Logistik-Aufgaben (z.B. sammeln, sortieren, verpacken, ...)."
                           ""
                           [:help :KatLogistik])
        (u-wanado-checkbox "... zur Unterstützung bei Sicherungsarbeiten (z.B Zutrittskontrolle, Portiertätigkeit)."
                           ""
                           [:help :KatSicherungsarbeiten])
        (u-wanado-checkbox "... zur Mithilfe bei Aufräumungsarbeiten."
                           ""
                           [:help :KatAufraeumungsarbeiten])
        (u-wanado-checkbox "... zur Unterstützung bei anderen Hilfsaktivitäten."
                           ""
                           [:help :KatHilfsaktivitaeten])



        [mui/grid
         {:container false
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "15px 15px 0 15px"}
          }
         [:h2
          "Ohne Katastrophe"]
         [:p
          "Ohne Katastrophe bin ich bereit ..."
          ]
         ]
        (u-wanado-checkbox "... zur Nachbarschaftshilfe."
                           ""
                           [:help :NormNachbarschaftshilfe])
        (u-wanado-checkbox "... für \\\"Einmal-Aufgaben\\\" (z.B. Individuelle Spontanhilfe)."
                           ""
                           [:help :NormEinmalAufgaben])
        (u-wanado-checkbox "... zur Unterstützung bei Projekten."
                           ""
                           [:help :NormProjekten])
        (u-wanado-checkbox "... zur Unterstützung in der Logistik."
                           ""
                           [:help :NormLogistik])
        (u-wanado-checkbox "... zur Unterstützung bei Rotkreuz-Veranstaltungen."
                           ""
                           [:help :NormRotkreuzVeranstaltungen])
        (u-wanado-checkbox "... zur administrativen Unterstützung."
                           ""
                           [:help :NormAdministrativen])
        (u-wanado-checkbox "... zur Durchführung von Marketing-Aufgaben."
                           ""
                           [:help :NormCampaigning])
        (u-wanado-checkbox "... zur Unterstützung bei anderen Hilfsaktivitäten."
                           ""
                           [:help :NormHilfsaktivitäten])



        (when tafel?
          [mui/grid
           {:container false
            :xs        12                                   ;extra-small: 0px
            :style     {:padding "15px 15px 0 15px"}
            }

           [:h2
            [:p (txt/txt :profile "Bei Team Tafel bin ich bereit ...")]]
           ])

        (when tafel? (u-wanado-checkbox "... gelegentlich mitzuarbeiten."
                                        ""
                                        [:help :tafel_once]))
        (when tafel? (u-wanado-checkbox "... regelmäßig mitzuarbeiten."
                                        ""
                                        [:help :tafel_regular]))
        (when tafel? (u-wanado-checkbox "... als Fahrer bei der Lebensmittelabholung zu unterstützen."
                                        ""
                                        [:help :tafel_driver]))
        (when tafel? (u-wanado-checkbox "... Helfer bei der Lebensmittelabholung mitzuarbeiten."
                                        ""
                                        [:help :tafel_helper]))
        (when tafel? (u-wanado-checkbox "... als Lebensmittelzusteller mitzuarbeiten."
                                        ""
                                        [:help :tafel_deliverer]))






        [mui/grid
         {:container false
          :md        5                                      ;medium: 960px
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "15px"}
          }
         [mui/button
          {:variant   "contained"
           :class     "bottom-button"
           :onClick   back-fn
           :startIcon (r/as-element [keyboard-arrow-left])
           }
          "Zurück"]]
        [mui/grid
         {:container false
          :md        5                                      ;medium: 960px
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "15px"}
          }
         [mui/button
          {:variant   "contained"
           :color     "primary"
           :startIcon (r/as-element [save])
           :class     "bottom-button"
           :onClick   save-fn
           }
          "Speichern"]

         ]

        ]]]]
    ))